import { Box, Button, ClickAwayListener, Container, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, stockParamsFormByStoreActions } from '../redux/store'
import axios from 'axios'
import { DOMAIN } from '../utils/api'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../utils/storage'
import { handleError } from '../utils/error'
import { borderFormat, mainGreen, mainGrey, mainRed } from '../utils/color'

export default function StockParamsByStoreForm(props) {
	const { stockParams } = useSelector((state) => state.stockParamsByStoreForm)
	const { currentUser } = useSelector((state) => state.currentUser)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [stockParamsEdit, setStockParamsEdit] = useState({
		values: {
			maxCapacity: stockParams.maxCapacity,
			lossRatio: stockParams.lossRatio,
			averageConsumption: stockParams.averageConsumption,
		},
		errors: { maxCapacity: '', lossRatio: '', averageConsumption: '' },
	})

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...stockParamsEdit.values, [name]: value }
		let newError = { ...stockParamsEdit.errors }

		if (name === 'maxCapacity') {
			if (Number(value) <= 0 && value.trim() !== '') {
				newError[name] = '* Sức chứa tối đa phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}
		if (name === 'lossRatio') {
			if (Number(value) <= 0 && value.trim() !== '') {
				newError[name] = '* Tỉ lệ hao hụt phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}
		if (name === 'averageConsumption') {
			if (Number(value) <= 0 && value.trim() !== '') {
				newError[name] = '* Tiêu thụ bình quân phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}
		setStockParamsEdit({ values: newValue, errors: newError })
	}

	const handleSubmit = async (event) => {
		event.preventDefault()
		const maxCapacity = stockParamsEdit.values.maxCapacity
		const lossRatio = stockParamsEdit.values.lossRatio
		const averageConsumption = stockParamsEdit.values.averageConsumption

		if (
			String(maxCapacity).trim() === '' ||
			String(lossRatio).trim() === '' ||
			String(averageConsumption).trim() === ''
		) {
			alert('Dữ liệu không được để trống')
			return
		}
		if (
			stockParamsEdit.errors.maxCapacity.trim() !== '' ||
			stockParamsEdit.errors.lossRatio.trim() !== '' ||
			stockParamsEdit.errors.averageConsumption.trim() !== ''
		) {
			return
		}
		try {
			await axios({
				url: `${DOMAIN}/sub-stock/edit/${currentUser.store}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { maxCapacity, lossRatio, averageConsumption },
			})
			await props.getSubStock()
			dispatch(stockParamsFormByStoreActions.hideStockParamsByStoreForm())
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	return (
		<ClickAwayListener
			onClickAway={() => {
				dispatch(stockParamsFormByStoreActions.hideStockParamsByStoreForm())
			}}>
			<Box>
				<Container
					onClick={(e) => {
						e.stopPropagation()
					}}
					onTouchEnd={(e) => {
						e.stopPropagation()
					}}
					sx={{
						background: mainGrey,
						borderTop: borderFormat,
						borderLeft: borderFormat,
						borderRight: borderFormat,
						maxWidth: '600px',
					}}
					maxWidth={false}>
					<Box noValidate display='flex' justifyContent='space-between' alignItems='center' sx={{ pt: 2 }}>
						{stockParamsEdit.errors.maxCapacity === '' ? (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Sức chứa tối đa
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.maxCapacity}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									id='maxCapacity'
									label='kg'
									name='maxCapacity'
									autoComplete='maxCapacity'
									onChange={handleChange}
								/>
							</Box>
						) : (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Sức chứa tối đa
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.maxCapacity}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									error
									id='maxCapacity'
									label='kg'
									name='maxCapacity'
									autoComplete='maxCapacity'
									onChange={handleChange}
								/>
							</Box>
						)}
						{stockParamsEdit.errors.lossRatio === '' ? (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Tỉ lệ hao hụt
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.lossRatio}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									id='lossRatio'
									label='%'
									name='lossRatio'
									autoComplete='lossRatio'
									onChange={handleChange}
								/>
							</Box>
						) : (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Tỉ lệ hao hụt
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.lossRatio}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									error
									id='lossRatio'
									label='%'
									name='lossRatio'
									autoComplete='lossRatio'
									onChange={handleChange}
								/>
							</Box>
						)}
					</Box>
					{stockParamsEdit.errors.averageConsumption === '' ? (
						<Box sx={{ mt: 2 }}>
							<Typography
								sx={{
									textAlign: 'center',
									background: mainGreen,
									color: '#fff',
									padding: '3px 0',
									borderRadius: '3px',
								}}>
								Tiêu thụ bình quân/ngày
							</Typography>
							<TextField
								fullWidth
								type='number'
								value={stockParamsEdit.values.averageConsumption}
								sx={{
									mt: 1,
									background: '#fff',
								}}
								id='averageConsumption'
								label='kg'
								name='averageConsumption'
								autoComplete='averageConsumption'
								onChange={handleChange}
							/>
						</Box>
					) : (
						<Box sx={{ mt: 2 }}>
							<Typography
								sx={{
									textAlign: 'center',
									background: mainGreen,
									color: '#fff',
									padding: '3px 0',
									borderRadius: '3px',
								}}>
								Tỉ lệ hao hụt
							</Typography>
							<TextField
								fullWidth
								type='number'
								value={stockParamsEdit.values.averageConsumption}
								sx={{
									mt: 1,
									background: '#fff',
								}}
								error
								id='averageConsumption'
								label='kg'
								name='averageConsumption'
								autoComplete='averageConsumption'
								onChange={handleChange}
							/>
						</Box>
					)}
					{stockParamsEdit.errors.maxCapacity && (
						<Typography sx={{ color: '#ff0000' }}>{stockParamsEdit.errors.maxCapacity}</Typography>
					)}
					{stockParamsEdit.errors.lossRatio && (
						<Typography sx={{ color: '#ff0000' }}>{stockParamsEdit.errors.lossRatio}</Typography>
					)}
					{stockParamsEdit.errors.averageConsumption && (
						<Typography sx={{ color: '#ff0000' }}>{stockParamsEdit.errors.averageConsumption}</Typography>
					)}
					<Box>
						<Button
							fullWidth
							type='button'
							variant='contained'
							sx={{
								mt: 2,
								mb: 2,
								background: mainRed,
								'&:hover': { background: mainRed },
							}}
							onClick={(e) => {
								handleSubmit(e)
							}}>
							Xác nhận
						</Button>
					</Box>
				</Container>
			</Box>
		</ClickAwayListener>
	)
}
